@use "@styles/variables";

:export {
    miscAlpha300: variables.$misc-alpha-300;
    miscAlpha200: variables.$misc-alpha-200;
    miscAlpha100: variables.$misc-alpha-100;
    miscAlpha50: variables.$misc-alpha-50;
    miscWhite: variables.$misc-white;

    miscAlpha300NoAlpha: variables.$misc-alpha-300-no-alpha;
    miscAlpha50NoAlpha: variables.$misc-alpha-50-no-alpha;

    gray900: variables.$gray-900;
    gray800: variables.$gray-800;
    gray700: variables.$gray-700;
    gray600: variables.$gray-600;
    gray500: variables.$gray-500;
    gray400: variables.$gray-400;
    gray300: variables.$gray-300;
    gray200: variables.$gray-200;
    gray100: variables.$gray-100;
    gray50: variables.$gray-50;

    red50: variables.$red-50;
    red100: variables.$red-100;
    red200: variables.$red-200;
    red300: variables.$red-300;
    red400: variables.$red-400;
    red500: variables.$red-500;
    red600: variables.$red-600;
    red700: variables.$red-700;
    red800: variables.$red-800;
    red900: variables.$red-900;

    yellow50: variables.$yellow-50;
    yellow100: variables.$yellow-100;
    yellow200: variables.$yellow-200;
    yellow300: variables.$yellow-300;
    yellow400: variables.$yellow-400;
    yellow500: variables.$yellow-500;
    yellow600: variables.$yellow-600;
    yellow700: variables.$yellow-700;
    yellow800: variables.$yellow-800;
    yellow900: variables.$yellow-900;

    green50: variables.$green-50;
    green100: variables.$green-100;
    green200: variables.$green-200;
    green300: variables.$green-300;
    green400: variables.$green-400;
    green500: variables.$green-500;
    green600: variables.$green-600;
    green700: variables.$green-700;
    green800: variables.$green-800;
    green900: variables.$green-900;

    blue50: variables.$blue-50;
    blue100: variables.$blue-100;
    blue200: variables.$blue-200;
    blue300: variables.$blue-300;
    blue400: variables.$blue-400;
    blue500: variables.$blue-500;
    blue600: variables.$blue-600;
    blue700: variables.$blue-700;
    blue800: variables.$blue-800;
    blue900: variables.$blue-900;

    purple50: variables.$purple-50;
    purple100: variables.$purple-100;
    purple200: variables.$purple-200;
    purple300: variables.$purple-300;
    purple400: variables.$purple-400;
    purple500: variables.$purple-500;
    purple600: variables.$purple-600;
    purple700: variables.$purple-700;
    purple800: variables.$purple-800;
    purple900: variables.$purple-900;

    white: variables.$white;
    black: variables.$black;
}
